import { VorgangProzessSchrittStatus, VorgangType } from '@core/domain';
import { TimelineElement } from '@/components/ui/timeline/timeline-types';
import { VorgangDetail } from '@/types';

// Prefix with VorgangDetail to avoid confusion
export type VorgangDetailSchritt =
  VorgangDetail['abarbeitungen'][number]['schritte'][number];

// Prefix with VorgangDetail to avoid confusion
export type VorgangDetailAbarbeitung = VorgangDetail['abarbeitungen'][number];

export const VORGANG_TYP_TRANSLATION_MAP = {
  [VorgangType.DUPLIKAT_VERSAND]: 'Duplikatversand',
  [VorgangType.POWERCLOUD_EVENT]: 'Powercloud',
  [VorgangType.CUSTOM_CONTRACT_EVENT]: 'Event Hub Vertragsevent',
  [VorgangType.GENERISCH]: 'Generisch',
};

export const STATUS_PROPERTY_MAP: Record<
  VorgangProzessSchrittStatus,
  Pick<TimelineElement, 'status' | 'color'>
> = {
  [VorgangProzessSchrittStatus.OFFEN]: {
    status: 'pending',
    color: 'secondary',
  },
  [VorgangProzessSchrittStatus.IN_BEARBEITUNG]: {
    status: 'in-progress',
    color: 'secondary',
  },
  [VorgangProzessSchrittStatus.ERLEDIGT]: {
    status: 'completed',
    color: 'primary',
  },
  [VorgangProzessSchrittStatus.FEHLER]: {
    status: 'error',
    color: 'destructive',
  },
};
